import { constants, mediaQueryStyles } from "@newsela/angelou";
import { VideoSubject } from "@/types/models/UnlevelledContent.interface";

const {
  colors: {
    product: { ela, science },
  },
} = constants;

const mathematicsBlue = "#11ACDB"; // Color does not exist in the Angelou library
const elaRed = ela[300];
const scienceOrange = science[500];

const VideoBackgroundUrl: Record<VideoSubject, string> = {
  [VideoSubject.LANGUAGE_ARTS]:
    "/images/generation-genius-ela-video-bg-pattern.svg",
  [VideoSubject.MATHEMATICS]: "/images/generation-genius-video-bg-pattern.svg",
  [VideoSubject.SCIENCE]: "/images/generation-genius-video-bg-pattern.svg",
};

export const SubjectColor: Record<VideoSubject, string> = {
  [VideoSubject.LANGUAGE_ARTS]: elaRed,
  [VideoSubject.MATHEMATICS]: mathematicsBlue,
  [VideoSubject.SCIENCE]: scienceOrange,
};

const { mobileFirstCss } = mediaQueryStyles;

// Shared responsive values for padding and minWidth
const responsiveSpacing = ["1em", "1em", "44px", "64px"];

export const playerColor = (subject: VideoSubject = VideoSubject.SCIENCE) => {
  return SubjectColor[subject];
};

export const geniusVideoWrapperCss = (
  subject: VideoSubject = VideoSubject.SCIENCE,
) =>
  mobileFirstCss({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: `
      url(${VideoBackgroundUrl[subject]})
      top left / contain repeat
      ${SubjectColor[subject]}
    `,
    padding: responsiveSpacing,
  });

export const geniusFigureCss = (isVideoOnly: boolean = false) =>
  mobileFirstCss({
    margin: "0",
    minWidth: responsiveSpacing.map((val) => `calc(100% - ${val})`),
    ...(isVideoOnly
      ? { maxWidth: "900px", margin: "0 auto", minWidth: undefined }
      : {}),
  });
